import { useEffect } from 'react';

interface SocialMetaTagsProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  author?: string;
  publishedTime?: string;
}

const SocialMetaTags = ({
  title,
  description,
  image = 'https://rakibhossentopu.online/images/og-share.jpg',
  url,
  type = 'website',
  author = 'Rakib Hossen Topu',
  publishedTime
}: SocialMetaTagsProps) => {
  
  useEffect(() => {
    const baseUrl = 'https://rakibhossentopu.online';
    const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
    const fullImage = image.startsWith('http') ? image : `${baseUrl}${image}`;

    // Helper function to set or create meta tag
    const setMetaTag = (property: string, content: string, isName = false) => {
      const attribute = isName ? 'name' : 'property';
      let meta = document.querySelector(`meta[${attribute}="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Keep <title>, <meta name="title">, <meta name="description"> in sync
    // with og:* / twitter:* so search and social previews always match.
    document.title = title;
    setMetaTag('title', title, true);
    setMetaTag('description', description, true);

    // Open Graph tags
    setMetaTag('og:title', title);
    setMetaTag('og:description', description);
    setMetaTag('og:image', fullImage);
    setMetaTag('og:url', fullUrl);
    setMetaTag('og:type', type);
    setMetaTag('og:site_name', 'Rakib Hossen Topu - SEO Expert in BD');
    setMetaTag('og:locale', 'en_US');

    // Twitter Card tags
    setMetaTag('twitter:card', 'summary_large_image', true);
    setMetaTag('twitter:title', title, true);
    setMetaTag('twitter:description', description, true);
    setMetaTag('twitter:image', fullImage, true);
    setMetaTag('twitter:site', '@rakibhassantopu', true);
    setMetaTag('twitter:creator', '@rakibhassantopu', true);

    // Article specific tags
    if (type === 'article') {
      setMetaTag('article:author', author);
      if (publishedTime) {
        setMetaTag('article:published_time', publishedTime);
      }
    }

    // Cleanup function - remove dynamically added tags when component unmounts
    return () => {
      // We don't remove tags on cleanup to avoid flickering
      // Tags will be updated when navigating to new pages
    };
  }, [title, description, image, url, type, author, publishedTime]);

  return null;
};

export default SocialMetaTags;
